import { Modal } from "antd5";

import { useDeleteLeads } from "../../lib/hooks/api/leads/useDeleteLeads";
import { pluralise } from "../../lib/utils";
import { Flex, Text } from "../../styles/utility-components";
import Button from "../ui/button/Button";
import toast from "../ui/toast/Toast";

type Props = {
  isOpen: boolean;
  selectedLeadIds: string[];
  onCancel: () => void;
  onSuccess: () => void;
  cancelText?: string;
};

export default function DeleteLeadsModal({
  isOpen,
  selectedLeadIds,
  onCancel,
  onSuccess,
  cancelText,
}: Props) {
  const { mutate: deleteLeads } = useDeleteLeads({
    onSuccess: (data) => {
      toast.success(`${pluralise(data.deleteLeads.length, "lead")} deleted successfully`);
      onSuccess();
    },
    onError: () => toast.error("Failed to delete leads"),
  });

  return (
    <Modal
      open={isOpen}
      centered
      footer={
        <Flex gap={16} justifyContent="flex-end">
          <Button as="button" buttonType="secondary" onClick={onCancel}>
            {cancelText ? cancelText : "Return to Lead"}
          </Button>
          <Button
            as="button"
            buttonStyle="destructive"
            onClick={() => deleteLeads({ ids: selectedLeadIds })}
          >
            {`Delete ${selectedLeadIds.length > 1 ? "Leads" : "Lead"}`}
          </Button>
        </Flex>
      }
      onCancel={onCancel}
    >
      <Flex flexDirection="column" gap={16}>
        <Text h3 bold>
          {`Delete ${selectedLeadIds.length > 1 ? "Leads" : "Lead"}`}
        </Text>
        <Text>
          {`Are you sure you want to delete ${selectedLeadIds.length > 1 ? "these leads" : "this lead"}? This action cannot be undone.`}
        </Text>
      </Flex>
    </Modal>
  );
}
